import React,{useEffect} from 'react';

import premiumRoom from '../../images/hotel1.jpg';
import { Button, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';

import { HashLink as Link } from 'react-router-hash-link';
import { BsBuilding } from "react-icons/bs";
import { BsTelephone } from "react-icons/bs";
import { BiLink } from "react-icons/bi";
import Aos from "aos";
import "aos/dist/aos.css";
import {useSelector} from 'react-redux';

import './AvailableRooms.css';
import AvailabilitiesCards from './AvailabilitiesCards';

function AvailableRoomsPage() {

    const posts = useSelector((state)=> state.posts);
    

    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <div>
            <section  className='HeaderPageWrapper'>
                <img src={premiumRoom} alt='tof' className='luxRoom' />
            </section>
            <div className='upperBox'>
                <h1 className='reservationH1'>Reservation</h1>
                    <p className='parag'> <BsBuilding size='17px' style={{verticalAlign:'top'}} /> 40 Anjannapa rs palya ms nagar kamanahalli bangalore 560033</p>
                    <p className='parag'><BsTelephone size='17px' style={{verticalAlign:'top'}} />    9178342471 / 080993456</p>
                    <p className='parag'><BiLink size='20px' style={{verticalAlign:'top'}} /> www.SaiShreyasResidency.in</p>
                
            </div>
            <section className='formContainerAvail'>
          <Form  className='formDis2'>
            <Row className='rowForm'>

                  <Col xl={2} lg={2} md={6} className='CheckInCol'>
                      <FormGroup>
                          <FormLabel>Check-in</FormLabel>
                          <FormControl  type='date' required />
                      </FormGroup>
                  </Col>
                  <Col xl={2} lg={2} md={6} className='CheckOutCol'>
                      <FormGroup>
                          <FormLabel>Check-out</FormLabel>
                          <FormControl type='date' required />
                      </FormGroup>
                  </Col>
                   <Col xl={2} lg={2} md={6} sm={6} className='GuestCol'>
                      <FormGroup>
                          <FormLabel>Guest</FormLabel>
                          <Form.Select  required>
                              <option value='' defaultValue hidden>No of rooms </option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                          </Form.Select>
                      </FormGroup>
                  </Col>
                  <Col xl={2} lg={2} md={6} sm={6} className='ChildCol'>
                    <FormGroup>
                        <FormLabel>Child</FormLabel>
                        <Form.Select  required>
                            <option value='' defaultValue hidden>No of children </option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                        </Form.Select>
                    </FormGroup>
                </Col>
                <Col xl={4} lg={4} className='AvailabilityCol'>
                  <Button className='AvailSubmitBtn'>UPDATE</Button>
                </Col>
            </Row>
          </Form>
        </section>
        <section>
            <Container style={{position:'relative',top:'20px'}}>
                <div >
                    <p> welcome {posts._id}</p>
                </div>
            </Container>
        </section>
        <section>
         <AvailabilitiesCards  />
        </section>
       
        </div>
    )
}

export default AvailableRoomsPage
